<div class="container" [attr.data-testid]="'error-dialog-container'">
  <div class="flex flex-row" [attr.data-testid]="'error-dialog-content'">
    <div class="error" [attr.data-testid]="'error-icon-wrapper'">
      <mat-icon [attr.data-testid]="'error-icon'">error</mat-icon>
    </div>
    <p [innerHTML]="content" [attr.data-testid]="'error-message'"></p>
  </div>
  <div class="button-wrap" [attr.data-testid]="'error-dialog-buttons'">
    @for (button of buttons; track button) {
      @switch (button.type) {
        @case ('raised') {
          <button
            mat-raised-button
            (click)="close(button.result)"
            [color]="button.color"
            [attr.data-testid]="'error-dialog-raised-button'"
          >
            {{ button.label }}
          </button>
        }
        @default {
          <button
            mat-button
            (click)="close(button.result)"
            [color]="button.color"
            [attr.data-testid]="'error-dialog-button'"
          >
            {{ button.label }}
          </button>
        }
      }
    }
  </div>
</div>
